<template lang="html">
    <div class="page" id="addCredits">
        <header class="pageHeader rounded">
            <fade-image class="darken" src="assets/headers/lessons.png" />
        </header>
        <div class="scroller2">
            <header>
                <h2>Lesson credits</h2>
                <ul class="links">
                    <li>
                        <router-link class="cancel" :to="{ name: 'playerLessons' }">
                            <x-icon class="icon" />
                        </router-link>
                    </li>
                </ul>
            </header>
            <div class="box" v-if="user.credits && Object.keys(user.credits).length">
                <div v-for="(credit, expiry) in user.credits" :key="credit.id" class="creditBox">
                    <p>{{ credit.length }} Lesson {{ "credit" | pluralize(credit.length) }}</p>
                    <span class="info" :class="{ expiring: isExpiring(expiry) }"
                        >Valid until {{ $date(expiry).format("D MMM YYYY") }}</span
                    >
                </div>
            </div>
            <div v-else class="box">
                <span style="color: #d08585">You have no lesson credits.</span>
            </div>
            <div
                v-if="!lessonTime && creditCost === false"
                class="box"
                style="line-height: 1.5; color: #267962"
            >
                You can't currently add credits because your Pro needs to set his lesson price and
                times in his lesson settings.
            </div>
            <div v-else>
                <empty-placeholder class="mt20" v-if="user.credits && user.credits.length == 0">
                    TIP! Book your lessons with the credits you add here. Make your first purchase
                    by tapping the button below.
                </empty-placeholder>
                <button
                    @click.prevent="creditsOpen = true"
                    class="button dark mb10 left"
                    type="button"
                    name="button"
                    v-show="!creditsOpen"
                >
                    Add Lesson credits
                    <plus-icon class="icon" />
                </button>
                <form class="form3" v-show="creditsOpen">
                    <div class="formGroup">
                        <select
                            :disabled="form.busy"
                            v-model="form.credits"
                            style="background: white"
                        >
                            <option :value="0">Select credit quantity</option>
                            <option v-for="n in 20" :key="n" :value="n">
                                Add {{ n }} {{ "credit" | pluralize(n) }}
                            </option>
                        </select>
                        <has-error :form="form" field="credits" />
                        <has-error :form="form" field="price" />
                    </div>
                    <div class="formGroup" v-show="form.credits > 0">
                        <span class="info"
                            >This will deduct
                            {{
                                creditCost | currency({ symbol: $store.state.user.currencySymbol })
                            }}
                            from your payment card that we have saved on file ending
                            {{ user.stripe_card }}.<br /><br />
                            {{ form.credits }} {{ "credit" | pluralize(form.credits) }} will give
                            you {{ lessonTime }} minutes of lesson tuition.
                        </span>
                        <button
                            :disabled="form.busy"
                            @click.prevent="buyCredits"
                            class="button"
                            type="button"
                            name="button"
                        >
                            {{ form.busy ? "Please wait..." : "Buy credits" }}
                        </button>
                    </div>
                </form>
                <empty-placeholder class="warning" v-if="user.credits && user.credits.length != 0">
                    IMPORTANT! Lesson credits must be used within 12 months of the purchase date.
                    You will be notified 1 month prior to credits expiring. Expired credits are
                    non-refundable.
                </empty-placeholder>
            </div>
        </div>
    </div>
</template>

<script>
import EmptyPlaceholder from "@/components/App/empty-placeholder";
import { Form, HasError } from "vform";
import { XIcon, PlusIcon } from "vue-feather-icons";
import FadeImage from "@/components/App/fade-image";
export default {
    name: "add-credits",
    components: { EmptyPlaceholder, XIcon, PlusIcon, FadeImage, HasError },
    mounted() {
        this.stripe = window.Stripe(process.env.VUE_APP_STRIPE_KEY);
        console.log(this.lessonTime);
        console.log(this.creditCost);
    },
    created() {
        this.$store.dispatch("getUserCredits");
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        lessonTime() {
            return this.form.credits * 15;
            /*
            if (!this.user.lesson_settings || !this.user.lesson_settings.lesson_duration) {return 0}
            var mins = Number(this.user.lesson_settings.lesson_duration) * this.form.credits;
            var hours = Math.floor(mins / 60);
            var minutes = mins % 60;
            var $string = hours+' '+this.$pluralize('hour',hours)+' ';

            if (minutes > 0 ) {
            $string+=minutes+' '+this.$pluralize('minute',minutes);
            }
            return $string;
            */
        },
        creditCost() {
            if (!this.user.lesson_settings || !this.user.lesson_settings.lesson_price) {
                return false;
            }
            return (this.user.lesson_settings.lesson_price / 100) * this.form.credits;
        },
    },
    data() {
        return {
            stripe: false,
            form: new Form({
                credits: 0,
                price: "",
                payment_made: false,
            }),
            creditsOpen: false,
        };
    },
    methods: {
        isExpiring($date) {
            var date1 = this.$date($date);
            var diff = date1.diff(this.$date(), "day");
            if (diff < 30) {
                return true;
            }
        },
        buyCredits() {
            if (!this.user.stripe_payment_method) {
                this.$notify("A payment card first needs to be added to your account");
                this.$router.push("/account/subscription");
                return;
            }

            this.$confirm(
                "Are you sure you want to purchase this offer?<br><br>This will deduct " +
                    this.$store.state.user.currencySymbol +
                    this.creditCost +
                    " from your payment card that we have saved on file ending " +
                    this.$store.state.user.stripe_card +
                    ".",
                () => {
                    this.form.price = this.user.lesson_settings.lesson_price * this.form.credits;

                    this.form
                        .post("/stripe/add-credits")
                        .then((response) => {
                            this.$store.dispatch("addCreditToUser", response.data);
                            this.$notify(
                                this.form.credits +
                                    " " +
                                    this.$pluralize("credit", this.form.credits) +
                                    " " +
                                    this.$pluralize("has", this.form.credits) +
                                    " been added to your account",
                            );
                            this.form.credits = 0;
                            this.creditsOpen = false;
                        })
                        .catch((error) => {
                            if (error.response.data.code == "authentication_required") {
                                this.authStripe(error.response.data);
                            } else {
                                this.$notify({
                                    type: "error",
                                    text: error.response.data.message,
                                });
                            }
                        });
                },
                "Yes",
                "No, cancel",
            );
        },
        authStripe(stripeResponse) {
            this.form.busy = true;
            this.stripe
                .confirmCardPayment(stripeResponse.intent.client_secret, {
                    payment_method: stripeResponse.intent.last_payment_error.payment_method.id,
                })
                .then((result) => {
                    if (result.error) {
                        // Show error to your customer
                        this.$notify({
                            type: "error",
                            text: result.error.message,
                        });
                        this.form.busy = false;
                    } else {
                        if (result.paymentIntent.status === "succeeded") {
                            this.form.payment_made = true;
                            this.form.post("/stripe/add-credits").then((response) => {
                                this.$store.dispatch("addCreditToUser", response.data);
                                this.$notify(
                                    this.form.credits +
                                        " " +
                                        this.$pluralize("credit", this.form.credits) +
                                        " " +
                                        this.$pluralize("has", this.form.credits) +
                                        " been added to your account",
                                );
                                this.form.credits = 0;
                                this.creditsOpen = false;
                                this.form.payment_made = false;
                            });
                        }
                    }
                });
        },
    },
};

/*
if (result.paymentIntent.status === 'succeeded') {
  this.form.post('/stripe/add-credits').then((response)=>{
    this.$store.dispatch('addCreditToUser',response.data);
    this.$notify(this.form.credits+' '+this.$pluralize('credit',this.form.credits)+' '+this.$pluralize('has',this.form.credits)+' been added to your account');
  });
}
*/
</script>

<style lang="scss" scoped>
#addCredits {
    .scroller2 {
        .creditBox {
            p {
                font-weight: 400 !important;
            }
            .info {
                height: 39px !important;
                min-height: 39px !important;
                padding-top: 10px;
                border-radius: 8px !important;
                &.expiring {
                    background: #d08585;
                    color: white;
                }
            }
        }
        .box {
            background: white;
            padding: 20px;
            border-radius: $radius;
            margin-bottom: 20px;
            p {
                color: $green_0;
                margin-bottom: 20px;
                font-weight: bold;
            }
        }
        .card {
            width: 100%;
            background: #e7efeb;
            border: 0px;
            padding: 20px;
            border-radius: 12px;
            font-size: 1rem;
            font-family: canada-type-gibson, sans-serif;
            -webkit-appearance: none;
            -moz-appearance: none;
            appearance: none;
            color: #267962;
            max-width: 100%;
            min-width: 100%;
        }
    }
}
</style>
